// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminAssetsShare = {
  share: {
    title: "共享资产",
    notice: "共享治理已从资产元数据编辑中独立出来，并直接遵循正式 shared-resource 模型。",
    publicDescription: "公共资产默认允许查看、引用与克隆。",
    selectedUsersTitle: "已共享用户",
    emptyUsers: "当前还没有定向共享用户",
    actions: {
      pickUsers: "选择用户",
    },
    fields: {
      capabilities: "能力",
    },
    capabilities: {
      view: "查看",
      reference: "引用",
      clone: "克隆",
    },
    errors: {
      requiredShareMode: "请选择共享模式",
      selectAtLeastOneUser: "请选择至少一个共享用户",
      selectCapabilities: "请至少选择一个共享能力",
    },
    messages: {
      saveSuccess: "资产共享设置已保存",
      saveFailed: "资产共享设置保存失败",
    },
  },
} as const;
